<script setup lang="ts">
import { MessageCircleIcon } from "lucide-vue-next";
import { computed } from "vue";

import { Button } from "@/components/ui/button";

interface Props {
  containerClass: string;
  title?: string;
  description?: string;
  showAction?: boolean;
  actionLabel?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Selecciona un hilo",
  description: "Elegí un hilo de la izquierda o creá uno nuevo.",
  showAction: false,
  actionLabel: "Crear hilo",
});

const emit = defineEmits<{
  action: [];
}>();

const hasDescription = computed(() => (props.description?.trim().length ?? 0) > 0);
</script>

<template>
  <div :class="containerClass">
    <div class="mx-auto max-w-sm px-6 text-center">
      <div
        class="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl border border-dashed border-border/80 bg-muted/30"
      >
        <MessageCircleIcon class="h-6 w-6 text-muted-foreground/50" />
      </div>
      <p class="text-sm font-semibold text-foreground/70">
        {{ title }}
      </p>
      <p
        v-if="hasDescription"
        class="mt-1.5 text-[13px] leading-relaxed text-muted-foreground/70"
      >
        {{ description }}
      </p>
      <Button
        v-if="showAction"
        class="mt-5"
        size="sm"
        type="button"
        @click="emit('action')"
      >
        {{ actionLabel }}
      </Button>
    </div>
  </div>
</template>
